var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiQuestionFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:question-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.9987 14.6654C4.3167 14.6654 1.33203 11.6807 1.33203 7.9987C1.33203 4.3167 4.3167 1.33203 7.9987 1.33203C11.6807 1.33203 14.6654 4.3167 14.6654 7.9987C14.6654 11.6807 11.6807 14.6654 7.9987 14.6654ZM7.33203 9.9987V11.332H8.66536V9.9987H7.33203ZM8.66536 8.90203C9.20114 8.74055 9.6611 8.392 9.96147 7.91986C10.2618 7.44772 10.3826 6.8834 10.3019 6.32968C10.2211 5.77595 9.9441 5.26966 9.52137 4.903C9.09864 4.53635 8.55828 4.33372 7.9987 4.33203C7.45927 4.33199 6.93647 4.5188 6.51923 4.86069C6.10198 5.20259 5.81604 5.67845 5.71003 6.20736L7.01803 6.46936C7.05515 6.28365 7.14424 6.1123 7.27494 5.97524C7.40564 5.83818 7.57257 5.74106 7.75631 5.69517C7.94006 5.64928 8.13305 5.6565 8.31284 5.71601C8.49264 5.77552 8.65184 5.88486 8.77192 6.0313C8.892 6.17775 8.96803 6.35529 8.99115 6.54326C9.01428 6.73123 8.98355 6.9219 8.90254 7.09309C8.82154 7.26427 8.69359 7.40894 8.53358 7.51025C8.37357 7.61156 8.18808 7.66535 7.9987 7.66536C7.82189 7.66536 7.65232 7.7356 7.52729 7.86063C7.40227 7.98565 7.33203 8.15522 7.33203 8.33203V9.33203H8.66536V8.90203Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiQuestionFill);
export default __webpack_public_path__ + "static/media/ri_question-fill.e8ddeff0eceff86947cc9c83dc9b1300.svg";
export { ForwardRef as ReactComponent };